<script setup lang="ts">
import { ParticipantLogo } from '@collector/shared-ui-domain'
import type { Participant } from '@collector/sportsapi-types'

type Props = {
  participant: Participant
}
defineProps<Props>()
</script>

<template>
  <div class="flex items-center gap-x-2">
    <span class="text-lg font-bold">Lineups</span>
    <ParticipantLogo :participant />
    <span class="w-full text-lg font-bold">
      {{ participant.short_name }}
    </span>
  </div>
</template>
